





































































import {
  Component,
  PropSync,
  Prop,
  Watch,
  Vue
} from 'vue-property-decorator';
import {
  lbzfIsMobileBreakpoint,
  lbzfLockBodyScroll
} from '../../utils/funcs';
import LbzIconButton from '../icon-button/icon-button.vue';
import LbzTopAppBar from '../top-app-bar/top-app-bar.vue';

@Component({
  components: {
    LbzIconButton,
    LbzTopAppBar
  }
})
export default class LbzDrawer extends Vue {
  // active.sync: true (default), false
  @PropSync('active', { type: Boolean, default: true })
  private cisActive!: boolean;

  // type: 'standard' (default), 'modal', 'bottom (mobile only)'
  @Prop({ type: String, default: '' }) private type!: string;
  // background (auto-darkened): 'primary', 'secondary', 'surface' (default), 'light', 'dark'
  @Prop({ type: String, default: '' }) private background!: string;
  // full-screen (type === 'bottom'): true, false (default)
  @Prop({ type: Boolean, default: false }) private fullScreen!: boolean;
  // title: '' (default), 'x'
  @Prop({ type: String, default: '' }) private title!: string;
  // subtitle: '' (default), 'x'
  @Prop({ type: String, default: '' }) private subtitle!: string;
  // lock-body-scroll: true (default), false
  @Prop({ type: Boolean, default: true }) private lockBodyScroll!: boolean;

  private visMobile = false;

  get cisStandard(): boolean {
    return ['', 'standard'].includes(this.type);
  }

  get cisFullScreen(): boolean {
    return this.type === 'bottom' && this.fullScreen;
  }

  @Watch('cisActive')
  private factiveChanged(val: boolean): void {
    this.$emit(val ? 'open' : 'close');

    if (this.lockBodyScroll) {
      lbzfLockBodyScroll(this.cisStandard ? this.visMobile && val : val);
    }
  }

  private mounted(): void {
    if (this.cisStandard) {
      this.fresize();
      window.addEventListener('resize', this.fresize);
    }
  }

  private beforeDestroy(): void {
    if (this.cisStandard) {
      window.removeEventListener('resize', this.fresize);
    }
  }

  private fresize(): void {
    if (!this.cisStandard) {
      return;
    }

    this.visMobile = lbzfIsMobileBreakpoint();

    if (this.lockBodyScroll && !this.visMobile && this.cisActive) {
      lbzfLockBodyScroll(false);
    }

    this.cisActive = !this.visMobile;
  }

  private ftoggle(): void {
    this.cisActive = !this.cisActive;
  }

  private fopen(): void {
    this.cisActive = true;
  }

  private fclose(): void {
    this.cisActive = false;
  }
}
